import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="relative bg-background-950 py-16 md:py-24 overflow-hidden">
      <div className="w-full px-4 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-12">
          <span className="inline-block self-start px-3 py-1 border border-white/20 rounded-full text-white/60 text-xs font-medium tracking-wider">
            Categories
          </span>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight lg:ml-auto lg:max-w-2xl">
            Popular Spreadsheet Product Categories
          </h2>
        </div>

        <div className="relative">
          <div className="flex gap-4 overflow-x-auto pb-4 -mx-4 px-4 md:px-10 snap-x snap-mandatory" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
            {categories.map((cat) => (
              <a
                key={cat.id}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex-shrink-0 w-[240px] md:w-[280px] snap-start group cursor-pointer"
              >
                <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-800">
                  <img
                    src={cat.imageUrl}
                    alt={`${cat.name} Hipobuy Spreadsheet category`}
                    title={`${cat.name} - Hipobuy Spreadsheet`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                </div>
                <div className="mt-3">
                  <h3 className="text-white text-sm md:text-base font-semibold">{cat.name}</h3>
                  <p className="text-white/50 text-xs mt-1">Browse {cat.name} collection</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}